/*
 * Luggage Finder -- site-wide floating tab + <luggage-finder-drawer>.
 *
 * The drawer no longer contains the quiz (that lives exclusively on the
 * dedicated Luggage Finder page now) -- its entire content is static markup
 * rendered by the section, so this file only wires up open/close/focus/Esc
 * behaviour via the theme's SideDrawer base class. There is no bundle to
 * lazy-load and nothing to instantiate on first open.
 */

/* global SideDrawer */

if (!customElements.get('luggage-finder-drawer')) {
  class LuggageFinderDrawer extends SideDrawer {
    constructor() {
      super();
      this.tabButton = document.getElementById(this.dataset.tabId);

      if (this.tabButton) {
        this.tabButton.addEventListener('click', this.handleTabClick.bind(this));
      }
    }

    /**
     * Handles a click on the floating tab: toggles the drawer open/closed.
     */
    handleTabClick() {
      if (this.getAttribute('open') !== null) {
        this.close();
      } else {
        this.open(this.tabButton);
      }
    }

    /**
     * Opens the drawer.
     * @param {Element} [opener] - Element that triggered opening of the drawer.
     */
    open(opener) {
      this.tabButton.setAttribute('aria-expanded', 'true');
      super.open(opener);
    }

    /**
     * Closes the drawer.
     * @param {Function} [callback] - Called after the close transition completes.
     */
    close(callback) {
      this.tabButton.setAttribute('aria-expanded', 'false');
      super.close(callback);
    }
  }

  customElements.define('luggage-finder-drawer', LuggageFinderDrawer);
}
